<script setup lang="ts">
import { computed, defineProps, ref, watch } from 'vue';
import { HasManyFieldType } from '@/components/business/crud/interface/FieldType';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import HasMany from '@/components/business/crud/widgets/impl/component/HasMany.vue';
import SelectModelTable from '@/components/business/crud/common/SelectModelTable.vue';

const props = defineProps<{
  propName: string;
  widget: HasManyFieldType;
  info: WidgetInfo;
}>();
const data = ScForm.useFormData();
const isCreate = computed(() => !data.value[props.widget.localPrimary]);

const models = ref([])
watch(models, () => {
  if (!data.value[props.propName]) {
    data.value[props.propName] = {};
  }
  data.value[props.propName].attach = models.value.map((i: any) => i[props.widget.targetPrimary]);
})

</script>

<script lang="ts">
import { definedWidgetMeta } from '@/components/business/crud/widgets/widgetManager';

export const meta = definedWidgetMeta({
  size: { edit: 'large', show: 'large' },
});
</script>

<template>
  <div>
    <select-model-table
      v-if="isCreate"
      v-model="models"
      :module-name="widget.targetModuleName"
      :controller-name="widget.targetController"
      :label-name="widget.targetLabel"
    />
    <has-many
      v-else
      :data="data"
      :info="info"
      :prop-name="propName"
      :widget="widget"
    />
  </div>
</template>

<style scoped lang="scss"></style>
